import styled from '../../styles/styled';
export const ButtonRow = styled.div(({ theme }) => ({
    display: 'inline-flex',
    '>*:not(:last-of-type)': {
        marginRight: theme.spacing.m,
    },
}));
//# sourceMappingURL=button_row.js.map